/**
 * Composant générique pour les listes de jauges (accès et tarifs).
 * Utilisé deux fois dans le parent avec des classes CSS différentes :
 *   variant="access" → .itacs / .nameacs / .jaugeacs / .progacs / .noitacs
 *   variant="tarif"  → .ittpl / .nametpl / .jaugetpl / .progtpl / .noittpl
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ScanRowVm } from '../tableau-de-bord.types';

@Component({
  selector: 'app-dashboard-scan-list',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  template: `
    @if (rows.length === 0) {
      <div [class]="emptyClass">
        {{ emptyLabel }}<span class="respdis70"> {{ emptyLabelSuffix }}</span><span class="respdis60"> dans cette liste.</span>
      </div>
    } @else {
      @for (row of rows; track row.id) {
        <div [class]="itemClass" [attr.id]="variant === 'access' ? row.id : null" [attr.tag]="row.totalS"
             style="width:100%;height:46px;line-height:46px;padding-left:4%;margin-top:3px;">
          <div [class]="nameClass">{{ row.name }}</div>
          <div [class]="gaugeClass">
            <div [class]="barClass" [style.width]="row.propScan + '%'">
              @if (row.propScan > 25) {
                <span class="mtper">{{ row.propScan }} %</span>
              }
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      }
    }
  `,
})
export class DashboardScanListComponent {
  @Input() rows: ScanRowVm[] = [];
  @Input() variant: 'access' | 'tarif' = 'access';

  get itemClass(): string  { return this.variant === 'access' ? 'itacs'    : 'ittpl'; }
  get nameClass(): string  { return this.variant === 'access' ? 'nameacs'  : 'nametpl'; }
  get gaugeClass(): string { return this.variant === 'access' ? 'jaugeacs' : 'jaugetpl'; }
  get barClass(): string   { return this.variant === 'access' ? 'progacs'  : 'progtpl'; }
  get emptyClass(): string { return this.variant === 'access' ? 'noitacs'  : 'noittpl'; }
  get emptyLabel(): string { return this.variant === 'access' ? 'Aucun accès'  : 'Aucun tarif'; }
  get emptyLabelSuffix(): string { return this.variant === 'access' ? 'associé' : 'présent'; }
}
